// Header scroll
let pst = null;
$(window).scroll(function() {
  let st = $(window).scrollTop();
  if ( st > 200 ) {
    $('body').addClass('body--header-scrolled');
  } else {
    $('body').removeClass('body--header-scrolled');
  }
  if ( st > 200 && pst !== null && pst < st ) {
    $('body').addClass('body--header-scrolled-down');
  } else {
    $('body').removeClass('body--header-scrolled-down');
  }
  pst = st;
});

// Menu
$(document).on('click', '.header__menu .expander',function(e) {
  if ( !is_mobile()) {
    return;
  }
  let $li = $(this).closest('li');
  e.preventDefault();
  e.stopPropagation();
  let was_open = $li.hasClass('open');
  $li.parent().find('li.open').removeClass('open').find('ul').slideUp(300);
  if ( !was_open ) {
    $li.addClass('open').find('ul').slideDown(300);
  }
});
$(document).on('click', '.header__menu-mobile-opener', function() {
  $('.header').addClass('header--menu-open');
});
$(document).on('click', '.header__menu-mobile__close', function() {
  $('.header').removeClass('header--menu-open');
});
$(document).on('click', '.header__menu', function(e) {
  if ( !$(e.target).is('.header__menu > ul')
    && !$(e.target).closest('ul').closest('.header__menu').length ) {
    $('.header').removeClass('header--menu-open');
  }
});

// Header pad resize
$(window).resize(function() {
  $('.header-pad').height($('.header').outerHeight());
});
